import { useEntityCollectionInitializer } from 'store/entityCollection';
import { useInspectionStore } from '../../store';

/** Binds the inspection list to the mounted view; loading and events are the store's actions. */
export function useInspectionsInitializer(): void {
  useEntityCollectionInitializer(useInspectionStore.use.inspectionsCollection());
}
